import { render, staticRenderFns } from "./PostAssociation.vue?vue&type=template&id=7184c8c1"
import script from "./PostAssociation.vue?vue&type=script&lang=js"
export * from "./PostAssociation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports